module.exports = __webpack_public_path__ + "static/media/profile.7c8a0670.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/profile.jpg
 ** module id = 510
 ** module chunks = 0
 **/